import { Stack } from '@mui/material'
import type { FC } from 'react'

import type { BenefitsDto } from '@hcr/api/optimizely'
import { COLORS, DividerWithLabel, unit } from '@hcr/ui'

import { createBenefitPreview } from '../benefit-preview'

interface BenefitsGroupProps {
  benefitsGroup: BenefitsDto['content'][0]
}

const benefitPreview = createBenefitPreview()

export const BenefitsGroup: FC<BenefitsGroupProps> = ({ benefitsGroup: { title, content } }) => {
  return (
    <Stack>
      <DividerWithLabel
        component='h2'
        bgcolor={COLORS.vaalea['60%']}
        paddingTop={unit(2.5)}
        paddingBottom={unit(2.75)}
        paddingLeft={unit(4)}
        paddingRight={unit(7)}
      >
        {title}
      </DividerWithLabel>
      {content.map(benefit => benefitPreview(benefit))}
    </Stack>
  )
}
